// lib/mutations/revokeAllSessions.js

import { axios } from 'lib/axios';
import { useMutation } from 'react-query';

export const revokeAllSessions = ({ userId }) => {
  return axios.post('/session/user/revokeAll', { userId });
};

export const useRevokeAllSessions = ({ config }) => {
  return useMutation({
    ...config,
    mutationFn: revokeAllSessions,
  });
};
